import type { AxiosInstance } from 'axios';
import type { CiselnikyCiselnikPolozkaSeznamDto } from '../generated';

export const countriesQuery = async (
	axiosInstance: AxiosInstance
): Promise<CiselnikyCiselnikPolozkaSeznamDto> => {
	const { data } = await axiosInstance.get(
		'/api/v1/ciselniky/ROB_STAT/polozky'
	);
	return data;
};
